import { render, staticRenderFns } from "./auth-salutation.vue?vue&type=template&id=01c781ca&"
import script from "./auth-salutation.vue?vue&type=script&lang=js&"
export * from "./auth-salutation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports